import React from 'react';

const SourceLink = props => {
  /* eslint-disable jsx-a11y/anchor-has-content */
  return (
    <a
      href={`${process.env.PUBLIC_URL}/trips`}
      rel="noopener noreferrer"
      {...props}
    />
  );
};

export default SourceLink;
